import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { parse } from 'json2csv';
import { Card } from 'antd';
import { getQueryParam } from '../../../../services/clientService';
import { ReportFilter } from './Components/ReportFilter';
import { TopAssetManagersTable } from './Components/TopAssetManagersTable';
import { ViewPanel } from '../../../../containers/view/ViewPanel';
import { getDefaultFilters } from '../../constants';

import { ZorbaButton } from '../../../../components/forms';
import { BUTTON_VARIANT_LIGHT } from '../../../../components/forms/ZorbaButton/constants';
import { showErrorToast } from '../../../../services/notificationsService';
import { useGetTopAssetManagers } from '../../../../queries/TopAssetManagersReport';

import './index.scss';

export const TopAssetManagersReport = () => {
  const queryParam = getQueryParam('query');
  const [searchCriteria, setSearchCriteria] = useState(
    getDefaultFilters(queryParam),
  );
  const [isMounted, setIsMounted] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const { appliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
    }
  }, []);

  const {
    data: topAssetManagersData,
    isLoading,
    isError,
  } = useGetTopAssetManagers({
    appliedFilters: { ...appliedFilters },
    isMounted,
  });

  useEffect(() => {
    if (!topAssetManagersData) return;

    const filtered = topAssetManagersData.filter((item) => {
      const searchQuery = searchCriteria.query?.toLowerCase() || '';
      return (
        item.organizationName?.toLowerCase().includes(searchQuery) ||
        item.ownerName?.toLowerCase().includes(searchQuery)
      );
    });

    setFilteredData(filtered);
  }, [topAssetManagersData, searchCriteria]);

  if (isError) {
    showErrorToast('Fetching report failed!');
  }

  const handleExportCSV = () => {
    if (!filteredData?.length) {
      showErrorToast('No data to export!');
      return;
    }

    const fields = ['organizationName', 'ownerName', 'assets'];
    try {
      const csv = parse(filteredData, { fields });
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('download', 'top-asset-managers.csv');
      a.click();
    } catch (error) {
      showErrorToast('Export failed!');
    }
  };

  return (
    <div className="top-asset-managers-report-page">
      <ViewPanel
        availableFilters={['state', 'cityCountyZip', 'numberOfUnits']}
        saveMode={false}
      >
        <div>
          <ZorbaButton
            variant={BUTTON_VARIANT_LIGHT}
            onClick={handleExportCSV}
            disabled={!filteredData?.length || isLoading}
          >
            Export to CSV
          </ZorbaButton>
        </div>
      </ViewPanel>
      <Card className="top-asset-managers-report-table-container">
        <ReportFilter
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
        />
        <TopAssetManagersTable
          isLoading={isLoading}
          topAssetManagersData={filteredData}
        />
      </Card>
    </div>
  );
};
